import FavoriteIcon from '@mui/icons-material/Favorite';
import { Badge, Fab } from "@mui/material";


function LikesBadge({ likes }) {
  return (
      <div>
      <Badge
        color="error"
        badgeContent={likes}
        showZero
        sx={{
          "& .MuiBadge-badge": {
            width: "50px",
            height: "25px",
            fontSize: "15px", // you may need to adjust this too
            minWidth: "unset",
            borderRadius: "2px"
          },
        }}
      >
      </Badge>
      </div>

  );
}

export default LikesBadge;

